import RouteModel, {IRouteModels} from "../../model-factory/basic/route/RouteModel";
import {RouteKey, FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import RouteChoice, {IRouteChoices} from "../../model-factory/basic/route/RouteChoice";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import ModelFactoryModel from "../../model-factory/basic/ModelFactoryModel";
import {AccountRouteModel} from "../../route/subject/AccountRouteFactory";
import {BrowseRouteModel} from "../../route/BrowseRouteFactory";
import {EndRouteModel} from "../../route/simple/EndRouteFactory";
import {LocatePageListRouteModel} from "../../route/locate/LocatePageListRouteFactory";
import {LocateRouteModel} from "../../route/locate/LocateRouteFactory";
import {MessageRouteModel} from "../../route/subject/message/MessageRouteFactory";
import {MessagePageListRouteModel} from "../../route/subject/message/MessagePageListRouteFactory";
import {MessageListRouteModel} from "../../route/subject/message/MessageListRouteFactory";
import {PostRouteModel} from "../../route/subject/PostRouteFactory";
import {PostListRouteModel} from "../../route/subject/PostListRouteFactory";
import {MyProfileRouteModel} from "../../route/subject/MyProfileRouteFactory";
import {IStringObject} from "../../common/SimpleInterface";
import {PostEntryRouteModel} from "../../route/subject/PostEntryRouteFactory";
import {PostStatusRouteModel} from "../../route/subject/PostStatusRouteFactory";
import {SubPageRouteModel} from "../../route/SubPageRouteFactory";

export class NavigationLevelVO
{
    model: RouteModel;
    factoryID: FactoryID;
    navigationRouteKey: RouteKey|null;

    choiceID: string = "";
    publicID: string = "";
    realPath: string = "";

    choice: RouteChoice | null = null;

    routeIDs: IRouteIDs = {};

    derivedModels: ModelFactoryModel[] = [];

    constructor(model: RouteModel, factoryID: FactoryID, navigationRouteKey:RouteKey|null)
    {
        this.model = model;
        this.factoryID = factoryID;
        this.navigationRouteKey = navigationRouteKey;
    }
}

class NavigationRouteModels
{
    browse:BrowseRouteModel|null = null;
    account:AccountRouteModel|null = null;

    myProfile:MyProfileRouteModel|null = null;
    post:PostRouteModel|null = null;
    postList:PostListRouteModel|null = null;
    postEntry:PostEntryRouteModel|null = null;
    archive:PostStatusRouteModel|null = null;

    locate:LocateRouteModel|null = null;
    locatePageList:LocatePageListRouteModel|null = null;
    message:MessageRouteModel|null = null;
    messagePageList:MessagePageListRouteModel|null = null;
    messageList:MessageListRouteModel|null = null;
    subPage:SubPageRouteModel|null = null;
    end:EndRouteModel|null = null;
}

export default class NavigationModel
{
    routeIDs: IRouteIDs = {};
    routeModels:NavigationRouteModels = new NavigationRouteModels();
    models: IRouteModels = {};
    choices: IRouteChoices = {};
    levelList: NavigationLevelVO[] = [];
    baseURL: string = "";
    href: string = "";
    realPath: string = "";
    activeChoice: RouteChoice | null = null;
    primaryHref: string = "";
    primaryChoice: RouteChoice | null = null;
    primaryRouteIDs: IRouteIDs = {};
    knownParams:IStringObject = {}

    constructor()
    {

    }

    addRouteModel(routeModel:RouteModel):void
    {
        switch(routeModel.factoryID)
        {
            case "browse_route":
                this.routeModels.browse = routeModel as BrowseRouteModel;
                break;
            case "account_route":
                this.routeModels.account = routeModel as AccountRouteModel;
                break;
            case "my_profile_route":
                this.routeModels.myProfile = routeModel as MyProfileRouteModel;
                break;
            case "post_route":
                this.routeModels.post = routeModel as PostRouteModel;
                break;
            case "post_list_route":
                this.routeModels.postList = routeModel as PostListRouteModel;
                break;
            case "post_entry_route":
                this.routeModels.postEntry = routeModel as PostEntryRouteModel;
                break
            case "locate_page_list_route":
                this.routeModels.locatePageList = routeModel as LocatePageListRouteModel;
                break;
            case "locate_route":
                this.routeModels.locate = routeModel as LocateRouteModel;
                break;
            case "message_route":
                this.routeModels.message = routeModel as MessageRouteModel;
                break;
            case "message_page_list_route":
                this.routeModels.messagePageList = routeModel as MessagePageListRouteModel;
                break;
            case "message_list_route":
                this.routeModels.messageList = routeModel as MessageListRouteModel;
                break;
            case "sub_page_route":
                this.routeModels.subPage = routeModel as SubPageRouteModel;
                break;
            case "end_route":
                this.routeModels.end = routeModel as EndRouteModel;
                break;
            default:
                break;
        }
        this.models[routeModel.factoryID] = routeModel;
    }

    constructQueryHref(params:IStringObject) {
        let query = "";
        for(let key in params) {
            const value = params[key];
            if(value){
                query += (!query ? "?" : "&") + key+"="+value;
            }
        }
        return this.baseURL+query;
    }

}